import React, { FormEvent, ReactNode } from 'react';
import styled from '@emotion/styled';
import { H3 } from '@leafygreen-ui/typography';
import Button, { ButtonProps } from '@leafygreen-ui/button';
import { MongoDBLogo } from '@leafygreen-ui/logo';

const buttonHeightAsDesigned = 48;

const Container = styled.div<{
  isForm: boolean;
}>`
  width: 100%;
  min-height: 636px;
  padding-bottom: ${(props) => (props.isForm ? `${buttonHeightAsDesigned + 16}px` : 0)};
  position: relative;
  box-sizing: border-box;
`;

const SubmitButton = styled<React.ComponentType<{ type?: string } & ButtonProps>>(Button)`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const Title = styled<React.ComponentType<Omit<React.ComponentProps<typeof H3>, 'as'>>>(H3)`
  margin: 0 0 24px;
`;

interface FormProps {
  buttonText: string;
  onSubmit: (e: FormEvent) => void;
  disabled?: boolean;
}

export default function VercelLayout({
  title = '',
  isForm = false,
  formProps = {
    buttonText: '',
    onSubmit: () => {},
    disabled: false,
  },
  children,
}: {
  title?: string;
  isForm?: boolean;
  formProps?: FormProps;
  children?: ReactNode;
}) {
  return (
    <Container isForm={isForm}>
      <MongoDBLogo height={32} css={{ marginBottom: '24px' }} />
      {title && <Title>{title}</Title>}
      {isForm ? (
        <form onSubmit={formProps.onSubmit} method="post" name="vercel-form">
          {children}
          <SubmitButton variant="primary" size="large" type="submit" disabled={formProps.disabled}>
            {formProps.buttonText}
          </SubmitButton>
        </form>
      ) : (
        <>{children}</>
      )}
    </Container>
  );
}
